import { createSelector } from 'reselect';
import { getAvailableRoomTypes } from './getAvailableRoomTypes';

export const getAvailableRoomTypeCount = createSelector(getAvailableRoomTypes, (availableRoomTypes) => availableRoomTypes.length);
